import React, { useState } from 'react';
import s from '../../styles/corporate/Corporate.module.css';
import { IMPACT } from './data';

/** 사회적 가치 — 항목을 누르면 설명이 펼쳐진다 */
const CorpImpact = () => {
  const [active, setActive] = useState(0);

  return (
    <section className={`${s.wrap} ${s.section} ${s.sectionLine}`} id="impact">
      <div className={s.impactGrid}>
        <div>
          <h2 className={`${s.h2} ${s.reveal}`} style={{ marginBottom: 24 }}>
            기업의 성장을 넘어,
            <br />
            사회의 더 큰 가치로.
          </h2>
          <p className={`${s.lead} ${s.reveal}`} data-delay="100" style={{ maxWidth: 460 }}>
            우리는 기술 발전과 비즈니스 성장이 더 많은 기업과 사람에게 기회가 되어야 한다고
            생각합니다. 산업의 경쟁력을 높이고, 지역사회와 구성원에게 긍정적인 변화를 만들어가는
            기업을 지향합니다.
          </p>
        </div>

        <div className={s.impactList}>
          {IMPACT.map((item, i) => (
            <button
              type="button"
              key={item.title}
              className={`${s.impactItem} ${i === active ? s.impactItemOn : ''}`}
              onMouseEnter={() => setActive(i)}
              onFocus={() => setActive(i)}
              onClick={() => setActive(i)}
              aria-expanded={i === active}
            >
              <span className={s.impactRow}>
                <span className={s.mono} translate="no">{`0${i + 1}`}</span>
                <span className={s.impactTitle}>{item.title}</span>
                <span className={s.impactDot} aria-hidden="true" />
              </span>
              <span className={`${s.collapse} ${i === active ? s.collapseOpen : ''}`}>
                <span>
                  <p className={s.impactBody}>{item.body}</p>
                </span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CorpImpact;
